import React from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import type { SxProps, Theme } from '@mui/material/styles';

import { AdminIcon, type AdminIconName } from '../icons/AdminIcon';

export interface AdminIconButtonProps {
  icon: AdminIconName;
  variant?: 'ghost' | 'outlined';
  size?: number;
  iconSize?: number;
  title?: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  sx?: SxProps<Theme>;
}

export const AdminIconButton: React.FC<AdminIconButtonProps> = ({
  icon, variant = 'ghost', size = 32, iconSize = 18, title, active, disabled, onClick, sx,
}) => {
  const btn = (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
      sx={{
        width: size,
        height: size,
        borderRadius: '8px',
        flexShrink: 0,
        color: active ? 'text.primary' : 'text.secondary',
        bgcolor: active ? 'action.selected' : variant === 'outlined' ? 'background.paper' : 'transparent',
        ...(variant === 'outlined' ? { border: '1px solid', borderColor: 'divider' } : {}),
        transition: 'background-color .12s ease, color .12s ease',
        '&:hover': { bgcolor: 'action.hover', color: 'text.primary' },
        '&.Mui-disabled': { opacity: 0.4 },
        ...(sx as object),
      }}
    >
      <AdminIcon name={icon} size={iconSize} />
    </ButtonBase>
  );
  return title ? <Tooltip title={title}>{btn}</Tooltip> : btn;
};

export default AdminIconButton;
